/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse
 */
export interface FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse
     */
    Sent: boolean;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse interface.
 */
export function instanceOfFxIdWebFeaturesFriendsSendFriendInviteNotificationResponse(value: object): value is FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse {
    if (!('Sent' in value) || value['Sent'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSON(json: any): FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Sent': json['Sent'],
    };
}

export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSON(json: any): FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSONTyped(value?: FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Sent': value['Sent'],
    };
}

